import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import {
  AddActivities,
  GetActivitiesById,
  UpdateActivities,
} from "../../../Redux/Reducers/ReportStage/Activities";
import Swal from "sweetalert2";
import $ from "jquery";
import { useNavigate } from "react-router-dom";

const ActivitesForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const GetActivitiesByIdResult = useSelector(
    (state) => state.Activities.Activities
  );

  const [ActivitesName, setActivitesName] = useState("");
  const [ActivitesNameValidation, setActivitesNameValidation] = useState(false);

  // Fetch existing activity on edit
  useEffect(() => {
    if (props.Action === "edit") {
      dispatch(
        GetActivitiesById({
          activitiesObjectivesId: props.activitiesObjectivesId,
        })
      );
    }
  }, [dispatch, props.Action, props.activitiesObjectivesId]);

  // Populate state after fetching for edit
  useEffect(() => {
    if (props.Action === "edit" && GetActivitiesByIdResult) {
      setActivitesName(GetActivitiesByIdResult.activitiesName || "");
    }
  }, [props.Action, GetActivitiesByIdResult]);

  const Validation = () => {
    const isEmpty = !ActivitesName || ActivitesName.trim() === "";
    setActivitesNameValidation(isEmpty);
    return !isEmpty;
  };

  const AddActivitesFunction = () => {
    if (Validation()) {
      dispatch(
        AddActivities({
          activitiesName: ActivitesName.trim(),
          reportId: props.reportId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }
  };

  const EditActivitesFunction = () => {
    if (Validation()) {
      dispatch(
        UpdateActivities({
          activitiesName: ActivitesName.trim(),
          reportId: props.reportId,
          activitiesObjectivesId: props.activitiesObjectivesId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
      navigate(""); // Replace with appropriate route
    }
  };

  const renderForm = () => (
    <>
      <InputAHSF
        fieldsName="ActivitesReport"
        show={true}
        disabled={props.shouldDisableFields}
        defaultValue={
          props.Action == "edit" ? GetActivitiesByIdResult?.activitiesName : ""
        }
        onChange={(e) => setActivitesName(e.target.value)}
        showValidationMessage={ActivitesNameValidation}
        validationMessage="حقل الاسم إجباري"
      />

      <div className="ConainerButtonAHSF">
        <ButtonAHSF
          onClick={
            props.Action === "edit"
              ? EditActivitesFunction
              : AddActivitesFunction
          }
          text="حفظ"
          show={true}
        />
      </div>
    </>
  );

  return (
    <>
      {props.Action === "edit"
        ? GetActivitiesByIdResult?.activitiesObjectivesId
          ? renderForm()
          : null
        : renderForm()}
    </>
  );
};

export default ActivitesForm;
